import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { useEffect } from 'react';
import { getPlGoals } from '../_redux/actions';
import { plGoalsSelector } from '../_redux/selectors';
import AppCard from 'shared/design-system/components/app-card';
import { Col, Row } from 'react-bootstrap';
import GaugeChart from '../_components/gauge-chart';

const PLGoals: React.FC = () => {
  const dispatch = useAppDispatch();
  const plGoals = useAppSelector(plGoalsSelector);
  const plGoalsMock = {
    budgetMargineProgettoLow: 10000, // stanghetta
    budgetMargineProgettoTarget: 100000, // max
    margineProgettoLow: 75000, // valore

    budgetRevenueLow: 119730000, // max
    revenueLow: 31020000, // valore

    budgetMargineProgettoPerc: 55, // max
    margineProgettoPerc: 28.54, // valore

    budgetMargineCommercialeGruppo: 15000000, // max
    margineCommercialeGruppo: 6480000, // valore
  };

  useEffect(() => {
    if (!plGoals) {
      dispatch(getPlGoals({ dashboardFilterObiettiviPlDto: {} }));
    }
  }, []);

  return (
    <AppCard title="Goals Monitoring" className="mt-3">
      <Row>
        {plGoals?.budgetMargineProgettoTarget !== undefined && plGoals?.margineProgettoLow !== undefined && (
          <Col xxl={3} lg={6} md={6} sm={12} className="mb-4">
            <GaugeChart
              max={plGoals?.budgetMargineProgettoTarget}
              value={plGoals?.margineProgettoLow}
              target={plGoals?.budgetMargineProgettoLow}
              title="Own portfolio project margins (€)"
            />
          </Col>
        )}
        {plGoals?.budgetRevenueLow !== undefined && plGoals?.revenueLow !== undefined && (
          <Col xxl={3} lg={6} md={6} sm={12} className="mb-4">
            <GaugeChart
              max={plGoals?.budgetRevenueLow}
              value={plGoals?.revenueLow}
              color="#228086"
              title="Own portfolio revenues"
            />
          </Col>
        )}
        {plGoals?.budgetMargineProgettoPerc !== undefined && plGoals?.margineProgettoPerc !== undefined && (
          <Col xxl={3} lg={6} md={6} sm={12} className="mb-4">
            <GaugeChart
              max={plGoals?.budgetMargineProgettoPerc}
              value={plGoals?.margineProgettoPerc}
              unit="%"
              title="Own portfolio project margins (%)"
            />
          </Col>
        )}
        {plGoals?.budgetMargineCommercialeGruppo !== undefined && plGoals?.margineCommercialeGruppo !== undefined && (
          <Col xxl={3} lg={6} md={6} sm={12} className="mb-4">
            <GaugeChart
              max={plGoals?.budgetMargineCommercialeGruppo}
              value={Number(plGoals?.margineCommercialeGruppo)}
              title="Margine commerciale di gruppo"
            />
          </Col>
        )}
      </Row>
    </AppCard>
  );
};

export default PLGoals;
